const validate = (r) => {
  if (r.data?.errorMsg && r.data?.errorMsg !== '0000') throw r.data;
};

export default function createAdOperationAPI(axios) {
  return {
    postAdList: async (page = 1, limit = 100, sort = 'UpdateTime', order = '-1') => {
      try {
        const data = {
          page,
          limit,
          sort,
          order,
        };

        const result = await axios.post('/api/Ad/List', data);
        validate(result);
        return result.data;
      } catch (error) {
        const errorMessage = {
          error: error.response && error.response.data ? error.response.data : error,
        };
        return errorMessage;
      }
    },
    // Ad.toNewJSON()
    postNewAd: async (data) => {
      try {
        const formData = new FormData();
        Object.keys(data).forEach((key) => {
          formData.append(key, data[key]);
        });
        const result = await axios.post('/api/Ad/New', formData, {
          headers: { accept: 'application/octet-stream' },
        });
        validate(result);
        return result.data;
      } catch (error) {
        const errorMessage = {
          error: error.response && error.response.data ? error.response.data : error,
        };
        return errorMessage;
      }
    },
    // Ad.toJSON()
    postUpdateAd: async (data) => {
      try {
        const result = await axios.post('/api/Ad/Update', data);
        validate(result);
        return result.data;
      } catch (error) {
        const errorMessage = {
          error: error.response && error.response.data ? error.response.data : error,
        };
        return errorMessage;
      }
    },
    postDeleteAd: async (id) => {
      try {
        const data = {
          id,
        };
        const result = await axios.post('/api/Ad/Delete', data);
        validate(result);
        return result.data;
      } catch (error) {
        const errorMessage = {
          id,
          error: error.response && error.response.data ? error.response.data : error,
        };
        return errorMessage;
      }
    },
    deleteAdMedia: async (id) => {
      try {
        const data = { id };
        const result = await axios.post(
          'api/AdContent/Delete',
          data,
        );
        validate(result);
        return result.data;
      } catch (error) {
        const errorMessage = {
          id,
          error: error.response && error.response.data ? error.response.data : error,
        };
        return errorMessage;
      }
    },
    getGooglePerformanceData: async (startDate, endDate) => {
      try {
        const data = {
          startDate,
          endDate,
        };
        const result = await axios.post(
          'api/Effect/Google',
          data,
        );
        validate(result);
        return result.data;
      } catch (error) {
        const errorMessage = {
          error: error.response && error.response.data ? error.response.data : error,
        };
        return errorMessage;
      }
    },
    getFacebookPerformanceData: async (startDate, endDate) => {
      try {
        const data = {
          startDate,
          endDate,
        };
        const result = await axios.post(
          'api/Effect/Facebook',
          data,
        );
        validate(result);
        return result.data;
      } catch (error) {
        const errorMessage = {
          error: error.response && error.response.data ? error.response.data : error,
        };
        return errorMessage;
      }
    },
    postAdMedia2: async (id, category, file) => {
      try {
        const formData = new FormData();
        formData.append('File', file);
        const result = await axios.post(
          'api/AdContent/Upload',
          formData,
          {
            params: { Id: id, Category: category },
          },
        );
        return result.data;
      } catch (error) {
        const errorMessage = {
          id,
          error: error.response && error.response.data ? error.response.data : error,
        };
        return errorMessage;
      }
    },
    postAdMedia: async (id, category, file) => {
      try {
        const newFile = new File([file], file.name, { type: file.type.slice(0, 50) });
        const formData = new FormData();
        formData.append('File', newFile);
        const result = await axios.post(
          'api/AdContent/Upload',
          formData,
          {
            params: { Id: id, Category: category },
          },
        );
        validate(result);
        return result.data;
      } catch (error) {
        const errorMessage = {
          id,
          error: error.response && error.response.data ? error.response.data : error,
        };
        return errorMessage;
      }
    },
    getAdAssets: async (id) => {
      try {
        const result = await axios.get(
          'api/AdContent/List',
          {
            params: { Id: id },
          },
        );
        validate(result);
        return result.data.resultData;
      } catch (error) {
        const errorMessage = {
          id,
          error: error.response && error.response.data ? error.response.data : error,
        };
        return errorMessage;
      }
    },
  };
}
